const getUserProcurement = {
  groupIds: '20,21,22,23',
  userType: '',
};

export default getUserProcurement;
